(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-ugc-feed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-ugc-feed]';
    var DRAG_THRESHOLD = 6;

    function enableDrag(rail) {
      var pointerId = null;
      var startX = 0;
      var startScroll = 0;
      var dragging = false;
      var suppressClick = false;

      rail.addEventListener('pointerdown', function (event) {
        suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        if (rail.scrollWidth <= rail.clientWidth) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        startScroll = rail.scrollLeft;
        dragging = false;
      });

      rail.addEventListener('pointermove', function (event) {
        if (pointerId === null || event.pointerId !== pointerId) return;

        var delta = event.clientX - startX;

        if (!dragging) {
          if (Math.abs(delta) < DRAG_THRESHOLD) return;
          dragging = true;
          rail.classList.add('is-dragging');
          rail.style.scrollSnapType = 'none';
          if (rail.setPointerCapture) {
            try {
              rail.setPointerCapture(pointerId);
            } catch (error) {
              /* pointer already released */
            }
          }
        }

        rail.scrollLeft = startScroll - delta;
        event.preventDefault();
      });

      function endDrag(event) {
        if (pointerId === null || (event && event.pointerId !== pointerId)) return;

        if (rail.releasePointerCapture) {
          try {
            rail.releasePointerCapture(pointerId);
          } catch (error) {
            /* capture already released */
          }
        }

        suppressClick = dragging;
        dragging = false;
        pointerId = null;
        rail.style.scrollSnapType = '';
        rail.classList.remove('is-dragging');
      }

      rail.addEventListener('pointerup', endDrag);
      rail.addEventListener('pointercancel', endDrag);

      rail.addEventListener(
        'click',
        function (event) {
          if (!suppressClick) return;
          suppressClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    }

    function enableProgress(root, rail) {
      var track = root.querySelector('[data-ugc-progress]');
      var bar = root.querySelector('[data-ugc-progress-bar]');
      if (!track || !bar) return;

      var frame = 0;

      function render() {
        frame = 0;

        var trackWidth = track.clientWidth || 0;
        var maxScroll = rail.scrollWidth - rail.clientWidth;

        if (trackWidth === 0) return;

        if (maxScroll <= 0) {
          bar.style.width = trackWidth + 'px';
          bar.style.transform = 'translateX(0)';
          return;
        }

        var ratio = rail.clientWidth / rail.scrollWidth;
        var thumbWidth = Math.max(trackWidth * ratio, 32);
        var progress = rail.scrollLeft / maxScroll;

        bar.style.width = thumbWidth + 'px';
        bar.style.transform = 'translateX(' + (trackWidth - thumbWidth) * progress + 'px)';
      }

      function schedule() {
        if (!frame) frame = window.requestAnimationFrame(render);
      }

      rail.addEventListener('scroll', schedule, { passive: true });

      if ('ResizeObserver' in window) {
        new ResizeObserver(schedule).observe(rail);
      } else {
        window.addEventListener('resize', schedule, { passive: true });
      }

      render();
    }

    function initFeed(root) {
      if (!root || root.dataset.ugcFeedReady === 'true') return;

      var rail = root.querySelector('[data-ugc-rail]');
      if (!rail) return;

      root.dataset.ugcFeedReady = 'true';

      enableDrag(rail);
      enableProgress(root, rail);
    }

    function initAll(scope) {
      var nodes = (scope || document).querySelectorAll(SELECTOR);
      for (var i = 0; i < nodes.length; i++) initFeed(nodes[i]);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll(document);
      });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
